export default __webpack_public_path__ + "static/media/SunMoonGlow.34351f56.svg";